import React from 'react';
import { StyleSheet, View } from 'react-native';
import { AppView, Indicator, Spacer } from 'design-system';
import StatusBar from 'design-system/StatusBar';
import useAppFrameDimensions from 'hooks/useAppFrameDimensions';
import { isWeb } from '../../../constants';
const LoadingView = () => {
    const { height } = useAppFrameDimensions(isWeb);
    return (<AppView type="secondary">
      <StatusBar animated barStyle="dark-content"/>
      <View style={styles.container}>
        <Spacer h={height / 3.2}/>
        <Indicator dark/>
      </View>
    </AppView>);
};
export default LoadingView;
const styles = StyleSheet.create({
    container: {
        flex: 1,
        alignItems: 'center',
        justifyContent: 'center',
    },
});
